import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import { NavDireita } from '../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/pages/MenuDireito/unidades.css'
import ModalCriar from './MenuDireito-Modal/ModalCadTexto'
import Modal from './MenuDireito-Modal/ModalEdiTexto'

function Texto() {
  var user = authService.getCurrentUser()
  const [textos, setTextos] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [searchClassificacao, setSearchClassificacao] = useState('')
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/texto/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setTextos(response.data)
      })
  }, [])
  const [classificao, setClassificao] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/classificacao/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setClassificao(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE TEXTOS DE CLASSIFICAÇÃO</TitlePage1>
            {/* <TitlePage2>Textos</TitlePage2> */}
          </TitleOfPage>
        </div>
        <div id="containerHead3">
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <select
              className="fnamePadrao"
              placeholder="Pesquisar"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchClassificacao(event.target.value)
              }}
            >
              <option value="">Todos</option>
              {classificao
                .filter(val => {
                  if (val.clsStatus === 1) {
                    return val
                  }
                })
                .map(classificacao => (
                  <option value={classificacao.clsDescricao}>
                    {classificacao.clsDescricao}
                  </option>
                ))}
            </select>
            <ModalCriar />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>Classificação</th>
              <th>Nota</th>
              <th>Descrição</th>
              <th>Status</th>
            </thead>
            <tbody>
              {textos
                .filter(val => {
                  if (searchTerm === '' && searchClassificacao === '') {
                    return val
                  } else if (
                    val.txtNotaTexto
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.txtTexto
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(texto => (
                  <tr
                    key={texto.IdTexto}
                    onClick={() => handleToggleComplete(texto)}
                  >
                    <td>{texto.txtNotaTexto}</td>
                    <td>{texto.txtNotaValor}</td>
                    <td>
                      <p className="Space2">{texto.txtTexto}</p>
                    </td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!texto.txtStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default Texto
